import angular from 'angular';
import appConfig from './app.config';
import appRun from './app.run';
import constants from './app.constants';
import dependenciesModule from './app.dependencies';
import sharedModule from './shared/shared';
import cartModule from './cart/cart';
import CatalogModule from './catalog/catalog';
import loginModule from './login/login';
import homeModule from './home/home';
import payZoneModule from './pay-zone/pay-zone';
import tunnelModule from './tunnel/tunnel';
import orders from './orders/orders';
import pqrsModule from './pqrs/pqrs';
import reportsModule from './reports/reports';
import templates from './templates/templates';
import paymentsAdvancesModule from './payments-advances/payments-advances';
import consultCrmModule from './consult-crm/consult-crm';
// import usersModule from './users/users';
// import salesHome from './sales-home/sales-home';
// import registerModule from './register/register';
// import knowUsModule from './know-us/know-us';
 import dashboardModule from './dashboard/dashboard';
// import contactModule from './contact/contact';
// import confirmationOrderModule from './confirmation-order/confirmation-order';
// import accountModule from './account/account';



let casaBlancaModule = angular.module('hoyos', [
  // knowUsModule.name,
  // accountModule.name,
  // confirmationOrderModule.name,
   dashboardModule.name,
  // contactModule.name,
  // registerModule.name,
  // salesHome.name,
  // usersModule.name,
  dependenciesModule.name,
  loginModule.name,
  payZoneModule.name,
  sharedModule.name,
  tunnelModule.name,
  reportsModule.name,
  CatalogModule.name,
  homeModule.name,
  orders.name,
  pqrsModule.name,
  templates.name,
  cartModule.name,
  paymentsAdvancesModule.name,
  consultCrmModule.name
])
  .constant('ngAuthSettings',constants)
  .config(appConfig)
  .run(appRun);
 

export default casaBlancaModule;





/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/app.js
 **/